import { Box, Typography } from '@mui/material';
import { ChartsLegend, DefaultizedPieValueType, PiePlot, pieArcLabelClasses } from '@mui/x-charts';
import { ResponsiveChartContainer } from '@mui/x-charts/ResponsiveChartContainer';
import { BoxWithHeader } from '../common';
import { DealerAccidentsOverviewProps } from './types';
import { processData } from './utils/processData';

export const DealerAccidentsOverviewOnPlacePie = ({ graphData }: DealerAccidentsOverviewProps) => {
  const chartData = processData({ data: graphData });
  if (!chartData) return null;

  const spotSolved = chartData?.reduce((acc, d) => acc + d.countSpotSolved, 0);
  const spotNotSolved = chartData?.reduce((acc, d) => acc + d.countSpotNotSolved, 0);

  const pieData = [
    {
      label: `Zajeté nehody (${spotSolved})`,
      value: spotSolved,
      color: 'green'
    },
    {
      label: `Nezajeté nehody (${spotNotSolved})`,
      value: spotNotSolved,
      color: '#C62327'
    }
  ];

  const getArcLabel = (params: DefaultizedPieValueType) => {
    return params.value.toString();
  };

  return (
    <BoxWithHeader
      title={
        <>
          <Typography variant="h6" fontWeight="bold">
            Zajeté a nezajeté nehody
          </Typography>
          <Typography variant="body2" color="gray">
            Přehled zajetých a nezajetých nehod
          </Typography>
        </>
      }
    >
      <Box width={1} height="300px">
        <ResponsiveChartContainer
          skipAnimation
          margin={{ bottom: 90 }}
          series={[
            {
              type: 'pie',
              data: pieData,
              arcLabel: getArcLabel
            }
          ]}
          sx={{
            [`& .${pieArcLabelClasses.root}`]: {
              fill: 'white',
              fontSize: 14
            }
          }}
        >
          <PiePlot />
          <ChartsLegend position={{ vertical: 'bottom', horizontal: 'middle' }} />
        </ResponsiveChartContainer>
      </Box>
    </BoxWithHeader>
  );
};
